import React from 'react';
import FilmTile from 'components/FilmTile/FilmTile';


const MobileFilmTile = props => (
  <div className="swiper-slide">
    <FilmTile {...props} />
  </div>
);

export default MobileFilmTile;
